<h2 mat-dialog-title>Update Profile</h2>

@if (profileForm) {
  <mat-dialog-content [formGroup]="profileForm">
    <div class="form-field-container">
      <mat-form-field class="full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          formControlName="email"
          maxlength="100"
          type="email"
          autocomplete="email"
          aria-describedby="email-error"
        />
        @if (profileForm.controls.email.hasError('required')) {
          <mat-error id="email-error">Email is required</mat-error>
        } @else if (profileForm.controls.email.hasError('email')) {
          <mat-error id="email-error">Please enter a valid email address</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="note-container">
      <strong>Note:</strong> You will not be able to change your email address if that address is
      assigned to another account.
    </div>

    <div class="form-field-container">
      <mat-form-field class="full-width">
        <mat-label>First Name</mat-label>
        <input
          matInput
          formControlName="firstName"
          maxlength="50"
          autocomplete="given-name"
          aria-describedby="first-name-error"
        />
        @if (profileForm.controls.firstName.invalid) {
          <mat-error id="first-name-error"
            >First Name is required and must be less than 50 characters</mat-error
          >
        }
      </mat-form-field>
    </div>

    <div class="form-field-container">
      <mat-form-field class="full-width">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          formControlName="lastName"
          maxlength="50"
          autocomplete="family-name"
          aria-describedby="last-name-error"
        />
        @if (profileForm.controls.lastName.invalid) {
          <mat-error id="last-name-error"
            >Last Name is required and must be less than 50 characters</mat-error
          >
        }
      </mat-form-field>
    </div>

    <div class="form-field-container">
      <mat-form-field class="full-width">
        <mat-label>Work Phone</mat-label>
        <input
          matInput
          formControlName="workPhone"
          placeholder="Enter phone in the format (000) 000-0000"
          autocomplete="tel-work"
        />
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button matButton="filled" (click)="save()" [disabled]="!profileForm.valid">
      <mat-icon>save</mat-icon>
      Save Changes
    </button>
    <button matButton="outlined" (click)="onCancel()">Close</button>
  </mat-dialog-actions>
}
